var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pagination-summary"},[_vm._v(" Displaying "),_c('b',{staticClass:"pagination-from"},[_vm._v(_vm._s(_vm.from))]),_vm._v(" - "),_c('b',{staticClass:"pagination-to"},[_vm._v(_vm._s(Math.min(_vm.to, _vm.total)))]),_vm._v(" out of "),_c('b',{staticClass:"pagination-total"},[_vm._v(_vm._s(_vm.total))])])
}
var staticRenderFns = []

export { render, staticRenderFns }